import { useDispatch, useSelector } from "react-redux";
import FilterPagesGeneral from "../../components/FilterPagesGeneral";
import { fetchListItems, setPageType } from "../../redux/actions/actions";
import { useEffect } from "react";

export default function DiscountRequests() {
  const filterMethods = ["requester", "discount_name", "status"];

  return (
    <FilterPagesGeneral
      pageName={"discount_request"}
      filterMethods={filterMethods}
    />
  );
}
